import { useState, useEffect } from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import AnuncioCard from '../components/anuncios/AnuncioCard';
import Loading from '../components/common/Loading';
import { Anuncio } from '../types';

export default function Favoritos() {
  const [favoritos, setFavoritos] = useState<Anuncio[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Em produção viria da API
    setTimeout(() => {
      setFavoritos([]);
      setLoading(false);
    }, 500);
  }, []);

  const handleRemoveFavorito = (id: string) => {
    setFavoritos(prev => prev.filter(f => f.id !== id));
  };

  if (loading) return <Loading />;

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">
          Meus Favoritos ({favoritos.length})
        </h1>

        {favoritos.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm p-12 text-center">
            <p className="text-6xl mb-4">❤️</p>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Nenhum favorito ainda
            </h2>
            <p className="text-gray-500 mb-6">
              Salve anúncios que você gostou para acompanhar depois
            </p>
            <a 
              href="/anuncios"
              className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700"
            >
              Explorar Anúncios
            </a>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {favoritos.map(anuncio => (
              <div key={anuncio.id} className="relative">
                <button
                  onClick={() => handleRemoveFavorito(anuncio.id)}
                  className="absolute top-2 right-2 z-10 bg-white rounded-full p-2 shadow-md hover:bg-red-50 transition-colors"
                  title="Remover dos favoritos"
                >
                  <span className="text-red-500">❤️</span>
                </button>
                <AnuncioCard anuncio={anuncio} />
              </div>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
